import React from 'react';

import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

import _get from 'lodash/get';

import {
  SYNC_TYPE_OPTIONS,
  DEFAULT_SYNC_TYPE,
  SYNC_TYPE_DESCRIPTION,
  DISABLED_SYNC_TYPE,
} from './ServicesEnableSettings.constants';
import { ActionSettingsPropType } from '../../AccountSettings.types';

import './ServicesEnableSettings.scss';

const propTypes = {
  actionSettings: ActionSettingsPropType.isRequired,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function ServicesEnableSettings({ actionSettings, onChange }) {
  const enabled = _get(actionSettings, 'settings.enabled');
  const servicesSyncType = _get(actionSettings, 'settings.locationSyncType', DEFAULT_SYNC_TYPE);
  const value = enabled ? servicesSyncType : DISABLED_SYNC_TYPE;

  function handleChange(option) {
    if (option === DISABLED_SYNC_TYPE) {
      onChange({ enabled: false, locationSyncType: servicesSyncType });
    } else {
      onChange({ enabled: true, locationSyncType: option });
    }
  }

  return (
    <div className="services-enable-settings">
      <div className="description">
        <em>{SYNC_TYPE_DESCRIPTION[value]}</em>
      </div>
      <Dropdown
        selection
        options={SYNC_TYPE_OPTIONS}
        value={value}
        onChange={(e, { value: selectedValue }) => handleChange(selectedValue)}
      />
    </div>
  );
}

ServicesEnableSettings.propTypes = propTypes;
ServicesEnableSettings.defaultProps = defaultProps;
